import React, { useEffect, useState } from 'react'
import styles from './App.module.scss'
import fetchData, { IpoLockupResult } from './utils/fetchData'
import { SortingDirection } from './components/ColumnHeader/ColumnHeader'
import Table from './components/Table/Table'
import Pagination from './components/Pagination/Pagination'
import Filters from './components/Filters/Filters'
import Loading from './components/Loading/Loading'
import { useSearchParams } from 'react-router-dom'

function extractSortingParams(sortBy: string|undefined): [string|undefined, SortingDirection|undefined] {
  if (!sortBy) {
    return [undefined, undefined]
  }

  const sortingParts = sortBy.split(' ', 2)
  const sortingColumn = sortingParts[0]
  const sortingDirection = sortingParts[1] ? (sortingParts[1] === SortingDirection.ASC ? SortingDirection.ASC : SortingDirection.DESC) : SortingDirection.ASC

  return [sortingColumn, sortingDirection]
}

function App() {
  const pageSize = 50

  const [searchParams, setSearchParams] = useSearchParams()
  const [result, setResult] = useState<IpoLockupResult>()
  const [loading, setLoading] = useState<boolean>(true)

  const page = searchParams.get('page') ? Number.parseInt(searchParams.get('page') as string) : undefined
  const type = searchParams.get('type') as string
  const timePeriod = searchParams.get('timePeriod') as string || '7'
  const marketCap = searchParams.get('marketCap') as string || 'all'
  const sortBy = searchParams.get('sortBy') as string
  const [sortingColumn, sortingDirection] = extractSortingParams(sortBy)

  async function handleFilterChange(filter: string, value: string) {
    searchParams.set(filter, value)
    setSearchParams(searchParams)
  }

  async function handleSortChange(column: string, direction: SortingDirection) {
    searchParams.set('sortBy', `${column} ${direction}`)
    setSearchParams(searchParams)
  }

  async function handlePageChange(page: number) {
    searchParams.set('page', `${page}`)
    setSearchParams(searchParams)
  }

  useEffect(() => {
    fetchData({
      page,
      type,
      timePeriod,
      marketCap,
      sortingColumn,
      sortingDirection,
      pageSize,
    })
      .then(data => setResult(data))
      .finally(() => setLoading(false))
  }, [page, type, timePeriod, marketCap, sortBy, pageSize, sortingDirection, sortingColumn])

  // useEffect(() => {
  //   const type = searchParams.get('type') as string || 'upcoming'
  //   const timePeriod = searchParams.get('timePeriod') as string || '7'
  //   const marketCap = searchParams.get('marketCap') as string || 'all'
  //   const sortBy = searchParams.get('sortBy') as string || undefined
  //   const page = Number.parseInt(searchParams.get('page') as string)
  //
  //   let sortingColumn, sortingDirection
  //
  //   if (sortBy) {
  //     const sortingParts = sortBy.split(' ', 2)
  //
  //     sortingColumn = sortingParts[0]
  //     sortingDirection = sortingParts[1] ? (sortingParts[1] === SortingDirection.ASC ? SortingDirection.ASC : SortingDirection.DESC) : SortingDirection.ASC
  //   }
  //
  //   setFilters({ type, timePeriod, marketCap, sortingColumn, sortingDirection, page })
  // }, [searchParams])

  const filters ={
    page,
    type,
    timePeriod,
    marketCap,
    sortBy,
    pageSize,
  }

  return (
    <div className={styles.container}>
      <Filters {...filters} onChange={handleFilterChange} />
      {loading && <Loading rows={pageSize} />}
      {!loading && (
        <>
          <Table data={result?.items || []} onSortClick={handleSortChange} sortingColumn={sortingColumn}
                 sortingDirection={sortingDirection} />
          <Pagination currentPage={page} totalResults={result?.total} pageSize={result?.page_size}
                      onPageChange={handlePageChange} />
        </>
      )}
    </div>
  )
}

export default App
